import { action } from "typesafe-actions";

import { message } from "antd";

import { GatePayload } from "../common_types";

import {
  DebugActionTypes,
  DebugSearchFormError,
  DebugSearchResult,
  StartSearchPayload,
  UnwrapLinkPayload,
} from "./types";

export const unwrapLinkRequest = (payload: UnwrapLinkPayload) => action(DebugActionTypes.UNWRAP_LINK_REQUEST, payload);

export const startSearchRequest = (payload: StartSearchPayload & GatePayload) =>
  action(DebugActionTypes.START_SEARCH_REQUEST, payload);
export const startSearchSuccess = () => action(DebugActionTypes.START_SEARCH_SUCCESS);
export const startSearchError = (errors: DebugSearchFormError, errorMessage?: { detail: string }) => {
  if (errorMessage) message.error(errorMessage.detail);
  return action(DebugActionTypes.START_SEARCH_ERROR, errors);
};

export const fetchDebugResultsRequest = (payload: { taskId: string }) =>
  action(DebugActionTypes.FETCH_DEBUG_SEARCH_RESULTS_REQUEST, payload);
export const fetchDebugResultsSuccess = (result: DebugSearchResult) =>
  action(DebugActionTypes.FETCH_DEBUG_SEARCH_RESULTS_SUCCESS, result);
export const fetchDebugResultsError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(DebugActionTypes.FETCH_DEBUG_SEARCH_RESULTS_ERROR);
};

export const removeSearchResults = () => action(DebugActionTypes.REMOVE_SEARCH_RESULTS);
